MemberOnly =
  init: ({}, done) ->
    # We want to set the width of the tooltip with the same width of the container.
    # And the gig tooltip code move the tooltip to the end of body
    expectedSize = $(".member-only").width()
    $tooltip = $("#member_only_tooltip")
    $tooltip.css("width", expectedSize)

    done()

module.exports = MemberOnly
